import { environment } from '../../../environments/environment';
import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'fullDateTime'
})
export class FullDateTimePipe implements PipeTransform {

  transform(value?: string | number | Date): unknown {
    if (!value) return value;

    const isHours12 = environment.isHours12;

    const date = moment(value);

    return date.format(`DD-MM-YYYY ${isHours12 ? 'hh:mm A' : 'HH:mm'}`);
  }

}